import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  content: {
  }
}));

export default useStyles;